<template>
    <div>
        <div class="cert">
            <div ng-if="cert" @click="certClick" class="certContainer"  :class="{ disabled: !isValid }" :title="[!isValid ? translate('certificateItem.certificateExpired') : '']" >
                <img src="@/assets/cert.png" style="float:left; padding-right:10px;"/>
                <div>
                    <div style="font-weight:bold;">{{cert.subjectCountry}} {{cert.subjectSerial}} {{cert.subject}}</div>
                    <div>{{cert.subjectEmail}}</div>
                    <div class="text-muted">
                        <small>{{translate('certificateItem.lastValid')}}: {{cert.notAfter | date}}</small>
                        <span v-if="!isValid" class="badge badge-danger ml-2">{{translate('certificateItem.certInvalid')}}</span>
                    </div>
                </div>
            </div>
            <button class="btn btn-primary detayButton" type="button" @click="certificateDetailModal = true">{{translate('certificateItemV2.detail')}}</button>
        </div>
        <!-- CERTIFICATE DETAIL MODAL BAŞLANGICI -->
        <div v-if="certificateDetailModal" class="modal fade show" style="display: block" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{translate('certificateItemV2.certificateSummary')}}</h5>
                        <button type="button" class="close" data-dismiss="modal" :aria-label="translate('close')" @click="certificateDetailModal = false">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" style="height:520px;">
                        <div class="certificate-text-container">
                            <p  v-if="certDetail.IsExpired" class="text-danger certificate-text">{{translate('certificateItemV2.certificateExpired')}}</p>
                            <p v-else class="text-success certificate-text">{{translate('certificateItemV2.certificateValid')}}</p>
                        </div>
                        <table class="sticky-table">
                            <thead>
                                <tr>
                                <th>{{translate('certificateItemV2.field')}}</th>
                                <th>{{translate('certificateItemV2.value')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{{translate('certificateItemV2.certificateOwner')}}</td>
                                    <td>{{ certDetail.Subject.Cn }}</td>
                                </tr>
                                <tr>
                                    <td v-if="certDetail.CertificateType == 'eMuhur' && certDetail.Subject.SerialNumber.length == 10">{{translate('certificateItemV2.vkn')}}</td>
                                    <td v-if="certDetail.CertificateType == 'eMuhur' && certDetail.Subject.SerialNumber.length != 10">{{translate('certificateItemV2.detsisNo')}}</td>
                                    <td v-else>{{translate('certificateItemV2.tckn')}}</td>
                                    <td>{{ certDetail.Subject.SerialNumber }}</td>
                                </tr>
                                <tr>
                                    <td>{{translate('certificateItemV2.certStart')}}</td>
                                    <td>{{ certDetail.NotBefore | datetime}}</td>
                                </tr>
                                <tr>
                                    <td>{{translate('certificateItemV2.certEnd')}}</td>
                                    <td>{{ certDetail.NotAfter | datetime}}</td>
                                </tr>
                                <tr>
                                    <td>{{translate('certificateItemV2.serialNo')}}</td>
                                    <td>{{ certDetail.SerialNo }}</td>
                                </tr>
                                <tr>
                                    <td>{{translate('certificateItemV2.issuer')}}</td>
                                    <td>{{ certDetail.Issuer.Cn }}</td>
                                </tr>
                                <tr>
                                    <td>{{translate('certificateItemV2.signatureAlgorithm')}}</td>
                                    <td>{{ certDetail.SignatureAlgorithm }}</td>
                                </tr>
                                <tr>
                                    <td>{{translate('certificateItemV2.certType')}}</td>
                                    <td>{{ certDetail.CertificateType }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="modal-footer footer-button-container">
                            <button type="button" class="btn btn-outline-secondary" @click="certificateDetailModal = false" data-dismiss="modal">{{translate('close')}}</button>
                            <button type="button" class="btn btn-primary"  @click="downloadCertificate">{{translate('certificateItemV2.downloadCert')}}</button>
                    </div>
                </div>
            </div>
        </div>
         <!-- CERTIFICATE DETAIL MODAL BİTİŞ -->
    </div>
</template>

<script>
export default {
    name:"CertificateItem",
    props: {
        cert: Object,
        loading: {
            type: Boolean,
            required: false,
            default: false
        },
        certDetail: Object,
    },
    data(){
        return{
            certificateDetailModal: false,
        }
    },
    computed: {
        lastValid(){
            return new Date(this.cert.notAfter);
        },
        isValid(){
            return this.lastValid > new Date()
        }
    },
    methods: {
        certClick($event){
            if(this.isValid && !this.loading)
                this.$emit('click', $event)
        },
        downloadCertificate(){
            const base64 = this.certDetail.Base64Certificate;
            const editedBase64 = '-----BEGIN CERTIFICATE-----' + base64 +'\n-----END CERTIFICATE-----';
            const blob = new Blob([editedBase64], {type: 'application/pkix-cert'});
            const url = URL.createObjectURL(blob);

            const user = this.certDetail.Subject.Cn ? this.certDetail.Subject.Cn : '';
            const link = document.createElement('a');
            link.setAttribute('download', user+' Certificate.cer');
            link.setAttribute('href', url)

            document.body.appendChild(link);

            link.click();

            document.body.removeChild(link)
        },
    }
}
</script>
<style scoped>
    .modal-body{
        padding: 0px;
    }
    .cert {
        padding: 10px;
        cursor:pointer;
        display: flex;
        flex-direction: row;
        width: 100%;
        justify-content: space-between;
        align-items: center;
    }

    .certContainer{
        width: 100%;
    }
    .cert:hover {
        background: #f5f5f5;
    } 

    .cert.disabled {
        cursor:not-allowed;
        opacity: 0.8;
    }
    .detayButton{
        display: flex;
        align-items: center;
        height: 40px;
    }

    .sticky-table {
        width: 100%;
        border-collapse: collapse;
    }

    .sticky-table th {
        position: sticky;
        top: 40px;
        background-color: #fff;
        padding-left: 8px;
    }

    .sticky-table th,
    .sticky-table td {
        padding: 8px;
        text-align: left;
        border-bottom: 1px solid #ddd;
    }

    .sticky-table td {
        padding-left: 8px;
    }

    .certificate-text-container{
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: white;
        padding-top: 10px;
        position: sticky;
        top: 0;
    }
    .certificate-text{
        font-weight: bold;
    }
</style>